/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./previewItem.vue?vue&type=template&id=fa779046&scoped=true&"
import script from "./previewItem.vue?vue&type=script&lang=js&"
export * from "./previewItem.vue?vue&type=script&lang=js&"
import style0 from "./previewItem.vue?vue&type=style&index=0&id=fa779046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa779046",
  null
  
)

export default component.exports